import React, { useEffect, useState } from "react";
import { withRouter, Route, Redirect, Link } from "react-router-dom";
import "./CreateSchedule.css";
import Tab from "../../../../../../Util/Tabs/Tab.js";
import { pageTransitions, transitionDuration } from '../../../../../../Util/PageTransitions';
import { getUrlToPush } from "../../../../../../Util/helper";
import back from "../../../../../../assets/arrow-back.svg";
import WeeklyMatchups from "./WeeklyMatchups/WeeklyMatchups";
import MatchupLocations from "./MatchupLocations/MatchupLocations";
import TheoreticalPlayoffBracket from "./TheoreticalPlayoffBracket/TheoreticalPlayoffBracket";
import axiosApi from "../../../../../../core/interceptor/interceptor";
import { config } from "../../../../../../config";
import getSearchParam from "../../../../../../hooks/UrlSearchParam";

function CreateSchedule(props) {
  const [messageDropEnable, setMessageDropEnable] = useState(false);
  const [confirmSchedule, setConfirmSchedule] = useState(false);
  const [reSchedule, setReSchedule] = useState(false);
  const [leagueId, setLeagueId] = useState(null);
  const [leagueInfo, setLeagueInfo] = useState(null);
  const [showConfirm, setShowConfirm] = useState(true);
  const [seasonId, setSeasonId] = useState(0);
  useEffect(() => {
    if (props.location &&
      props.location.state) {
      if (props.location.state.season_id) {
        setSeasonId(Number(props.location.state.season_id));
      }
      if (props.location.state.leagueId) {
        setLeagueId(Number(props.location.state.leagueId));
      }
      if (props.location.state.leagueInfo) {
        setLeagueInfo((props.location.state.leagueInfo));
      }
    } else {
      const league_param_id = getSearchParam(props.location).get('leagueId');
      if (typeof league_param_id === 'string' &&
        !isNaN(league_param_id) &&
        !isNaN(Number(league_param_id))) {
        setLeagueId(Number(league_param_id));
        getLeagueInfo(Number(league_param_id));
      } else {
        setLeagueId(0);
      }
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    const tabs_ = tabs;
    if (leagueId >= 1) {
      tabs_.forEach(tab => {
        tab.search = `?leagueId=${leagueId}${(seasonId) ? `&season_id=${seasonId}` : ''}`;
      });
      setTabs(tabs_);
    }
    //eslint-disable-next-line
  }, [leagueId]);

  const [tabs, setTabs] = useState([
    {
      name: 'Weekly Matchups',
      url: '/weekly-matchups',
    },
    {
      name: 'Matchup Locations',
      url: '/matchup-locations',
    },
    {
      name: 'Theoretical Playoff Bracket',
      url: '/playoff-bracket',
    }
  ]);

  const getLeagueInfo = (id) => {
    axiosApi.get(`${config.apiUrl}/misc/league/season/info/${id}`).then((res) => {
      setLeagueInfo(res.data.data);
    }).catch((err) => {
      console.error(err);
    })
  }


  return (
    <>
      {leagueId && leagueInfo && <div className='outer-wrapper' initial={pageTransitions.initial} animate={pageTransitions.in} exit={pageTransitions.out} transition={{ duration: transitionDuration }}>
        <div className={messageDropEnable ? 'overlay' : ''} onClick={() => setMessageDropEnable(false)}></div>
        <div className="content-wrapper users-wrapper createSchedule-wrapper">
          <div className="leaguesGroups-wrapper">
            <div className="heading-wrapper">
              <div className="header-blk">
                <Link to={{
                  pathname: getUrlToPush('league_groups'),
                  search: `?leagueId=${leagueId}${(seasonId) ? `&season_id=${seasonId}` : ''}`,
                }}>
                  <button
                    className="back-btn btn-primary">
                    <img src={back} alt='back-league' />Back to League
                  </button>
                </Link>
                {
                  showConfirm &&
                  <>
                    <div className="schedule-button-wrapper">
                      <button className="btn-primary" onClick={() => setConfirmSchedule(true)}>Confirm Schedule</button>
                      <button className="btn-primary" onClick={() => setReSchedule(true)}>Re-Schedule</button>
                    </div>
                  </>
                }

              </div>
              <h2 className="heading">Create Schedule</h2>
              <p>{leagueInfo.name} - {leagueInfo.no_of_weeks} Weeks</p>
            </div>
          </div>
          <Tab tabs={tabs} emit={(e) => {
            if (e) {
              let confirmBtn = true;
              if (e === '/playoff-bracket') {
                confirmBtn = false;
              }
              setShowConfirm(confirmBtn);
            }
            setConfirmSchedule(false)
            setReSchedule(false)
          }} />
          <Route path={`${props.match.path}`} exact>
            <Redirect to={{
              pathname: `${props.match.path}/weekly-matchups`,
              search: `?leagueId=${leagueId}${(seasonId) ? `&season_id=${seasonId}` : ''}`
            }} />
          </Route>
          <Route path={`${props.match.path}/weekly-matchups`} exact>
            <WeeklyMatchups confirmSchedule={confirmSchedule} reSchedule={reSchedule} emit={() => {
              setConfirmSchedule(false)
              setReSchedule(false)
            }} />
          </Route>
          <Route path={`${props.match.path}/matchup-locations`}>
            <MatchupLocations confirmSchedule={confirmSchedule} reSchedule={reSchedule} emit={() => {
              setConfirmSchedule(false)
              setReSchedule(false)
            }} />
          </Route>
          <Route path={`${props.match.path}/playoff-bracket`}>
            <TheoreticalPlayoffBracket />
          </Route>
        </div>
      </div>}
    </>
  );
}

export default withRouter(CreateSchedule);
